import { SuccessResponseList } from './common'

export enum EScopeLevel {
  // User Management Page Invitation
  ORGANIZATION = 'organization',
  // Deliverable Set Invitation
  PROJECT = 'project',
  DELIVERABLE_SET = 'deliverable_set',
}

/**
 * DTO for filtering and paginating role list requests with scope-level filtering.
 */
export interface RequestListRoles {
  /** Dictionary of fields to filter the role list by. Allowed fields: role_name.
- `role_name`: Filter by specific role names (e.g., ['project_lead', 'reviewer'])
 */
  filter_by?: { [key: string]: unknown[] } | null
  limit?: number | null
  offset?: number | null
  /** Search term to filter roles by role_name or description (case-insensitive ILIKE) */
  q?: string | null
  /** Filter roles by hierarchical scope level:
- `organization`: All roles (Organization Admin, Project Lead, Team Member, Reviewer, Viewer)
- `project`: Project-level roles (Project Lead, Team Member, Reviewer)
- `deliverable_set`: Deliverable-level roles (Team Member, Reviewer)
If omitted, returns all roles without scope filtering. */
  scope_level?: EScopeLevel | null
  /** Field to sort the role list by. Prefix with '+' for ascending or '-' for descending order. Allowed fields: role_name.
- `+role_name`: Sort by role name ascending
 */
  sort_by?: string | null
  /** Variant of the model to return, affecting the fields included in the response. */
  variant?: string
}

/**
 * DTO for basic role response data without permissions.
 */
export interface ResponseRoleList {
  description?: string | null
  id: string
  role_name: string
}

export interface SuccessResponsePaginatedResponseResponseRoleList extends SuccessResponseList<ResponseRoleList> {}
